/**
 * assertNever is used to ensure exhaustiveness:
 * - in switch statements
 * - or if statements with a union type.
 *
 * The type system will report an error if a condition is missing
 * At runtime, it will throw an error if the code is reached.
 * @param x - the value to check
 */
export function assertNever(x: never): never {
  console.error("Unexpected code path for value: ", x);
  // @ts-expect-error when it's not never because runtime 😉
  throw new Error(`Unexpected code path for value: ${x?.toString()}`);
}

/**
 * Throw as an expression, e.g. `value ?? raise("missing value")`.
 */
export function raise(message: string): never {
  throw new Error(message);
}
